// src/services/api.js

import axios from 'axios';

// Obtener la URL base del backend
const baseURL = process.env.REACT_APP_API_URL;

if (!baseURL) {
  console.warn(
    "⚠️ No se encontró REACT_APP_API_URL en las variables de entorno. Usando 'http://localhost:8000/api' por defecto."
  );
}

// ========================================
// 🔐 API CON AUTENTICACIÓN (para Dashboard)
// ========================================
const api = axios.create({
  baseURL: baseURL || 'http://localhost:8000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// 🔑 INTERCEPTOR DE REQUEST - Añade token automáticamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 🔄 INTERCEPTOR DE RESPONSE - Maneja errores de autenticación
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.warn('Token expirado o inválido. Redirigiendo al login...');
      
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

// ========================================
// 🌐 API PÚBLICA (sin autenticación)
// ========================================
const publicApi = axios.create({
  baseURL: baseURL || 'http://localhost:8000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// ⚠️ IMPORTANTE: Esta instancia NO tiene interceptores de autenticación
// Se usa para endpoints públicos como registro de socios y listado público

// Solo logs para debugging en desarrollo
if (process.env.NODE_ENV === 'development') {
  publicApi.interceptors.request.use(
    (config) => {
      console.log('🌐 PublicApi Request:', config.method.toUpperCase(), config.url);
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  publicApi.interceptors.response.use(
    (response) => {
      console.log('✅ PublicApi Response:', response.status, response.config.url);
      return response;
    },
    (error) => {
      console.error('❌ PublicApi Error:', error.response?.status, error.response?.data);
      return Promise.reject(error);
    }
  );
}

// ========================================
// 📤 API PARA FORM DATA (subida de archivos con autenticación)
// ========================================
const apiFormData = axios.create({
  baseURL: baseURL || 'http://localhost:8000/api',
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

// Añadir token si existe (para subida autenticada)
apiFormData.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ========================================
// 📤 API PÚBLICA PARA FORM DATA (subida sin autenticación)
// ========================================
const publicApiFormData = axios.create({
  baseURL: baseURL || 'http://localhost:8000/api',
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

// Esta instancia NO tiene interceptores de autenticación
// Se usa para subida de archivos en registro público (ej: foto de socio)

if (process.env.NODE_ENV === 'development') {
  publicApiFormData.interceptors.request.use(
    (config) => {
      console.log('📤 PublicApiFormData Request:', config.method.toUpperCase(), config.url);
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  publicApiFormData.interceptors.response.use(
    (response) => {
      console.log('✅ PublicApiFormData Response:', response.status);
      return response;
    },
    (error) => {
      console.error('❌ PublicApiFormData Error:', error.response?.status, error.response?.data);
      return Promise.reject(error);
    }
  );
}

export default api;
export { publicApi, apiFormData, publicApiFormData };